import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { once } from '@web/utils';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminShippingSettingsDataSourceService } from '../../services/admin-shipping-settings-data-source.service';
import { AdminShippingSettingsFormData } from '../../models/admin-shipping-settings-form-data';
import { AdminShippingSettingsFormComponent } from '../admin-shipping-settings-form/admin-shipping-settings-form.component';

@Component({
  selector: 'app-admin-shipping-settings',
  imports: [
    CommonModule,
    AlertsComponent,
    SpinnerFilledComponent,
    AdminShippingSettingsFormComponent,
  ],
  templateUrl: './admin-shipping-settings.component.html',
  styleUrl: './admin-shipping-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminShippingSettingsComponent implements OnInit {
  private readonly shippingSettingsDataSource = inject(
    AdminShippingSettingsDataSourceService,
  );
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  protected data$!: Observable<AdminShippingSettingsFormData>;

  public ngOnInit(): void {
    this.data$ = this.shippingSettingsDataSource.fetchSettingsFormData();
  }

  public handleSubmitClick(data: AdminShippingSettingsFormData): void {
    this.shippingSettingsDataSource
      .updateSettingsByFormData(data)
      .pipe(once())
      .subscribe({
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
